import { render } from "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=template&id=07310e49&scoped=true"
import script from "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=script&lang=js"
export * from "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=script&lang=js"

import "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=style&index=0&id=07310e49&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07310e49"]])

export default __exports__